import React from 'react'
import './Styles/productdetails.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SampleNextArrow from './SampleNextArrow';
import SamplePrevArrow from './SamplePrevArrow';
import { RWebShare} from 'react-web-share';
import { useDispatch } from 'react-redux';
import {addtocart} from '../app/features/cart'
function Poductid({productd}) {
  const dispatch = useDispatch();
  const producturl = window.location.href;
  const title=productd.title;
  const text=productd.description;
  const added =()=>{
   alert('added to cart');
   dispatch(addtocart(productd));
  }
  const Buypro =()=>{
    alert('Buyproduct');
  }
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow:<SampleNextArrow/>,
    prevArrow:<SamplePrevArrow/>
  };
  var sliderim = JSON.parse(JSON.stringify(productd.images));
  return (
    <>
    <div className='productidd'>
    <div className="productid-details">
    <div className="category">{productd.category}</div>
    <div className="title">{productd.title}  Brand: {productd.category}</div>
   <div className="description">{productd.description}</div>
    </div>
   <hr />
   <div className="sliderim">
<Slider {...settings}>
  { sliderim.map((icon,index)=>{
    return<div>
      <div className='productdim' key={index}><img style={{maxHeight:'20em'}} src={icon} alt={icon}/></div>
      <div style={{textAlign:'center'}}>{index+1}</div>
    </div>
   })}
</Slider>
   </div>
  <RWebShare
   data={{
   title:{title},
   text:{text},
   url:{producturl}
   }}
   onClick={()=>console.log('succ')}>
<button>share</button>
  </RWebShare>
   <div className="buyproduct">
    <div className="addtocart buy">
      <button onClick={added}>Add To Cart</button>
    </div>
    <div className="Buyp buy">
      <button onClick={Buypro}>Buy Product</button>
    </div>
    <div className='prtp'>
    &#x20B9; {productd.price}00
    </div>
   </div>
    </div>
    </>
  )
}

export default Poductid
